// 신청 버튼 중복 클릭 방지 + "접수 중" 안내 + 네이버 광고 전환 기록
// 네이버 전환유형: 4 = 신청/예약, 5 = 기타(전화 클릭)

let submitting = false;

const OVERLAY_ID = 'submit-guard-overlay';

const showOverlay = () => {
  if (document.getElementById(OVERLAY_ID)) return;
  const el = document.createElement('div');
  el.id = OVERLAY_ID;
  el.setAttribute('role', 'alert');
  el.style.cssText = [
    'position:fixed', 'inset:0', 'z-index:99999', 'display:flex',
    'align-items:center', 'justify-content:center', 'background:rgba(0,0,0,0.55)'
  ].join(';');
  el.innerHTML =
    '<div style="background:#fff;border-radius:16px;padding:32px 28px;max-width:86%;text-align:center;box-shadow:0 10px 30px rgba(0,0,0,.25)">' +
    '<div style="width:52px;height:52px;margin:0 auto 18px;border:6px solid #e3f4f7;border-top-color:#0099b0;border-radius:50%;animation:sg-spin 0.9s linear infinite"></div>' +
    '<div style="font-size:22px;font-weight:800;color:#222;margin-bottom:10px">접수 중입니다</div>' +
    '<div style="font-size:17px;color:#555;line-height:1.5">잠시만 기다려 주세요.<br>버튼을 다시 누르지 않으셔도 됩니다.</div>' +
    '</div><style>@keyframes sg-spin{to{transform:rotate(360deg)}}</style>';
  document.body.appendChild(el);
};

const hideOverlay = () => {
  const el = document.getElementById(OVERLAY_ID);
  if (el) el.remove();
};

// 신청 시작: 이미 보내는 중이면 false (중복 전송 차단)
export const startSubmit = () => {
  if (submitting) return false;
  submitting = true;
  showOverlay();
  return true;
};

export const endSubmit = () => {
  if (navigating) return; // 완료 페이지로 넘어가는 중에는 '접수 중' 화면 유지
  submitting = false;
  hideOverlay();
};

export const trackNaverConversion = (type = '4', value = '1') => {
  try {
    if (window.wcs && window.wcs.cnv) {
      const nasa = { cnv: window.wcs.cnv(type, value) };
      window.wcs_do(nasa);
    }
  } catch (e) { /* 광고 스크립트 없으면 무시 */ }
};

// 전화번호(tel:) 클릭
// - 휴대폰: 그대로 전화 앱 열림 + 네이버 전환(5) 기록
// - PC: 전화 앱이 없어 아무 반응이 없으므로, 번호를 크게 보여주는 안내창 표시
const isPhoneDevice = () =>
  /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent) ||
  (window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

const PHONE_POPUP_ID = 'phone-popup-overlay';

const showPhonePopup = (number) => {
  const old = document.getElementById(PHONE_POPUP_ID);
  if (old) old.remove();
  const el = document.createElement('div');
  el.id = PHONE_POPUP_ID;
  el.setAttribute('role', 'dialog');
  el.style.cssText = 'position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.55);padding:16px';
  el.innerHTML =
    '<div style="background:#fff;border-radius:16px;padding:36px 32px 28px;max-width:420px;width:100%;text-align:center;box-shadow:0 10px 30px rgba(0,0,0,.25);word-break:keep-all">' +
    '<div style="font-size:19px;font-weight:700;color:#555;margin-bottom:8px">전화 상담</div>' +
    '<div style="font-size:42px;font-weight:900;color:#0099b0;letter-spacing:1px;margin-bottom:10px">' + number + '</div>' +
    '<div style="font-size:16px;color:#666;line-height:1.6;margin-bottom:24px">상담 시간 평일 9:00 ~ 18:00<br>휴대폰으로 위 번호에 전화 주세요.</div>' +
    '<button type="button" data-act="copy" style="width:100%;padding:16px;font-size:18px;font-weight:800;color:#fff;background:#0099b0;border:0;border-radius:10px;cursor:pointer;font-family:inherit">번호 복사</button>' +
    '<button type="button" data-act="close" style="width:100%;margin-top:10px;padding:14px;font-size:17px;font-weight:700;color:#555;background:#f0f0f0;border:0;border-radius:10px;cursor:pointer;font-family:inherit">닫기</button>' +
    '</div>';
  document.body.appendChild(el);
  el.addEventListener('click', (e) => {
    const act = e.target.getAttribute && e.target.getAttribute('data-act');
    if (e.target === el || act === 'close') { el.remove(); return; }
    if (act === 'copy') {
      const done = () => { e.target.textContent = '복사되었습니다 ✓'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(number).then(done, done);
      } else { done(); }
    }
  });
};

export const setupPhoneClickTracking = () => {
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (!a) return;
    if (isPhoneDevice()) {
      trackNaverConversion('5', '1');
      return; // 전화 앱으로 연결
    }
    e.preventDefault();
    showPhonePopup(a.getAttribute('href').replace('tel:', ''));
  }, true);
};

// 신청 완료 → 별도 '신청 완료' 페이지로 이동 (KT 홈페이지와 같은 흐름: 접수 중 → 신청 완료 페이지)
// kind: consult(상담 신청) | schedule(상담 예약) | estimate(견적 신청) | question(질문)
let navigating = false;

export const goSuccess = (kind) => {
  navigating = true;
  try { sessionStorage.setItem('salt-conversion', kind); } catch (e) { /* 무시 */ }
  window.location.assign('/success?type=' + encodeURIComponent(kind));
};
